import Routes from 'Routes';

import { useContext } from 'react';
import { useLocation } from 'react-router-dom';

import {
	BOOKMARKS,
	CALENDAR,
	POPULAR,
	SIGNALS
} from 'constants/locations';
import { LIVE_MASTER_CLASS_QUERY } from 'constants/queryParams';
import { useTranslationsContext } from 'contexts/translationsContext';
import { UserContext } from 'contexts/userContext';
import { getQueryParam } from 'utils/getQueryParam';

import {
	IconLayoutGrid,
	IconChartLine,
	IconCalendarWeek,
	IconPlayerPlayFilled
} from '@tabler/icons-react';

import { FXSNavLink, FXSNavLinkLiveMasterClass, FXSNavMenu } from './styles';

export default function NavMenu() {
	const { t } = useTranslationsContext();
	const { user } = useContext(UserContext);
	const { isPremium } = user;

	const location = useLocation();
	const splitLocation = location.pathname.split('/')[1].toLowerCase();

	const isDashboard =
		splitLocation === '' ||
		splitLocation === POPULAR ||
		splitLocation === BOOKMARKS;

	const isMasterClassNavLinkActive =
		location.pathname === Routes.MASTERCLASS || false;

	return (
		<FXSNavMenu>
			<FXSNavLink
				to={Routes.HOME}
				activeClassName={isDashboard ? 'fxs_active' : ''}
				data-ga4event-clk-name='sidebar_click'
				data-ga4event-element='dashboard'
			>
				<IconLayoutGrid stroke={isDashboard ? 2.5 : 1.5} style={{ marginRight: '8px' }} />
				<span>{t('dashboard')}</span>
			</FXSNavLink>
			<FXSNavLink
				exact
				to={Routes.SIGNALS}
				activeClassName='fxs_active'
				data-ga4event-clk-name='sidebar_click'
				data-ga4event-element='signals'
			>
				<IconChartLine stroke={splitLocation === SIGNALS ? 2.5 : 1.5} style={{ marginRight: '8px' }} />
				<span>{t('signals')}</span>
			</FXSNavLink>
			<FXSNavLink
				exact
				to={Routes.CALENDAR}
				activeClassName='fxs_active'
				data-ga4event-clk-name='sidebar_click'
				data-ga4event-element='economic-calendar'
			>
				<IconCalendarWeek stroke={splitLocation === CALENDAR ? 2.5 : 1.5} style={{ marginRight: '8px' }} />
				<span>{t('Calendar')}</span>
			</FXSNavLink>
			{isPremium && isLiveMasterClass() && (
				<FXSNavLinkLiveMasterClass
					isLiveMasterclass={isLiveMasterClass()}
					exact
					to={Routes.MASTERCLASS}
					activeClassName='fxs_active'
					data-ga4event-clk-name='sidebar_click'
					data-ga4event-element='masterclass'
				>
					<IconPlayerPlayFilled stroke={isMasterClassNavLinkActive ? 2.5 : 1.5} style={{ marginRight: '8px' }} />
					<span>{t('liveMasterclass')}</span>
				</FXSNavLinkLiveMasterClass>
			)}
		</FXSNavMenu>
	);
	function isLiveMasterClass() {
		let isActive = window['isLiveMasterclass'];
		if (getQueryParam(LIVE_MASTER_CLASS_QUERY))
			isActive = parseInt(getQueryParam(LIVE_MASTER_CLASS_QUERY));
		return isActive > 0;
	}
}
